import Vue from 'vue'
import Router from 'vue-router'
import Lobby from '@/components/Lobby/index'
import Test from '@/components/Lobby/test'

Vue.use(Router)

export default new Router({
	routes: [{
		path: '/',
		name: 'Lobby',
		component: Lobby,
		meta: {
			navShow: true
		}
	},{
    path: '/test',
    name: 'Test',
    component: Test,
    meta: {
      navShow: true
    }
  }, ]
})



// WEBPACK FOOTER //
// ./src/router/index.js